module.exports = __webpack_public_path__ + "img/bosnia-and-herzegovina.834689d8.svg";